import { AfterViewInit, Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({ selector: '[pcpCrossoriginImage]' })
export class CrossoriginImageDirective {
    /**
     * Image URL as input.
     * Attribute `acrossorigin` will be set on the element depending on the image url.
     */
    @Input() set pcpCrossoriginImage(imageUrl: string | null | undefined) {
        if (imageUrl && imageUrl.startsWith('https://nl9ye2mzk643e7no.blob.core.windows.net')) {
            this.el.nativeElement.setAttribute('crossorigin', 'anonymous');
        } else {
            this.el.nativeElement.removeAttribute('crossorigin');
        }
    }

    constructor(private el: ElementRef) {
    }


}
